
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/data-labeling",
      function () {
        return require("private-next-pages/services/data-labeling.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/data-labeling"])
      });
    }
  